import { Step } from 'modules/auth/components/SignupStepper/Step'
import { useSignupStepper } from 'modules/auth/hooks/useSignupStepper'
import { useSignupStoreType } from 'modules/auth/store/useSignupStore'
import { ResponsiveImage } from 'modules/common/components/ResponsiveImage/ResponsiveImage'
import { useAppContextState } from 'modules/common/contexts/AppContext'
import { useTranslation } from 'modules/common/hooks/useTranslation'

export const SignupStepper = () => {
  const { brand } = useAppContextState()

  const steps = useSignupStepper()

  const { t } = useTranslation('auth-components')

  const signupType = useSignupStoreType()

  return (
    <div className="hidden flex-initial flex-col justify-center bg-primary px-10 py-8 text-white md:m-2 md:flex md:w-80 md:space-y-8 md:rounded-3xl md:px-4 lg:w-96 lg:px-12">
      <ResponsiveImage
        src="/assets/svg/logo-white.svg"
        alt={`${brand}-logo`}
        className="w-32"
      />
      <div className="flex flex-col space-y-1">
        <h2>{t('signupStepper.title')}</h2>
        <p>{t('signupStepper.description', { context: signupType })}</p>
      </div>
      <div className="flex flex-col justify-between bg-primary">
        {steps.map(({ key, ...props }, index) => (
          <Step key={key} {...props} stepNumber={index + 1} />
        ))}
      </div>
    </div>
  )
}
